import classNames from "classnames";
import { Button } from "components/ui/button";
import { XIcon } from "lucide-react";
import { Color } from "utils/theme";

interface Props {
  show: boolean;
  title: string;
  className?: string;
  titleColor?: string;
  showCloseButton?: boolean;
  onClose?: () => void;
  children: React.ReactNode;
}

export const Modal = ({
  show,
  title,
  titleColor = Color.White,
  className,
  showCloseButton = false,
  onClose,
  children,
}: Props) => {
  if (!show) return null;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        if (onClose) onClose();
      }}
      className="absolute z-40 top-0 left-0 right-0 bottom-0 backdrop-blur-[2px] flex items-center justify-center transition-all"
      style={{ background: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="fixed inset-0 flex w-full h-full items-center justify-center">
        <div
          className={classNames(
            "relative rounded-2xl border max-w-[90%] max-h-[90%] overflow-hidden flex flex-col p-4",
            className
          )}
          style={{
            background: Color.Primary[900],
            borderColor: Color.Primary[700],
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {title && (
            <h2
              className="text-center font-medium text-xl my-2"
              style={{ color: titleColor }}
            >
              {title}
            </h2>
          )}
          {showCloseButton && onClose && (
            <Button
              className="absolute top-4 right-4"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              variant="ghost"
              size="icon"
            >
              <XIcon className="size-6" />
            </Button>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};
